import { format, parse } from "date-fns";

export function convertDateStringToMonthYear(dateString: string): string {
  if (!dateString) return "";
  try {
    const parsedDate = parse(dateString, "dd/MM/yyyy", new Date());
    return format(parsedDate, "MMM yyyy");
  } catch (error) {
    console.error("An error occurred:", error);
    return "";
  }
}
